var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',{attrs:{"transform":("translate(" + (-_vm.margin) + "," + (0) + ")")}},[_c('text',{attrs:{"transform":("translate(" + _vm.text_x + "," + _vm.text_y + ")rotate(-90)"),"dy":"5"}},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }